<template>
  <div>
    <PageTitle :title="$t('global.plan-architecture')" />
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "PlanArchitecturePage",
  components: { PageTitle },
  setup() {
    // plan has already been fetched by parent component
    const plan = computed(() => store.state.plans.plan);

    return {
      plan,
    };
  },
};
</script>
